import '@/App.css';

import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import { GoogleMapsProvider } from './context/GoogleMapsContext';
import { AuthGate } from './components/AuthGate';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { SchedulePage } from './pages/SchedulePage';
import { GalleryPage } from './pages/GalleryPage';
import { AccommodationsPage } from './pages/AccommodationsPage';
import { VenuePage } from './pages/VenuePage';
import { WhereToVisitPage } from './pages/WhereToVisitPage';
import { FAQPage } from './pages/FAQPage';
import { RegistryPage } from './pages/RegistryPage';
import { RSVPPage } from './pages/RSVPPage';
import { Footer } from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <GoogleMapsProvider>
        <AuthProvider>
          <AuthGate>
            <div className="App" data-testid="wedding-app">
              <Navigation />
              <main>
                <div id="home"><HomePage /></div>
                <div id="venue"><VenuePage /></div>
                <div id="schedule"><SchedulePage /></div>
                <div id="rsvp"><RSVPPage /></div>
                <div id="faq"><FAQPage /></div>
                <div id="accommodations"><AccommodationsPage /></div>
                <div id="explore"><WhereToVisitPage /></div>
                <div id="registry"><RegistryPage /></div>
                <div id="gallery"><GalleryPage /></div>
              </main>
              <Footer />
            </div>
          </AuthGate>
        </AuthProvider>
      </GoogleMapsProvider>
    </LanguageProvider>
  );
}

export default App;
